import { IntegrationAuthenticationIssueCode } from '../../../../../../typings/api/integrations/leica/rest/v1/skymap-leica-connection';
import { t } from '../../../../utils/i18-next';
import { assertNever } from '../../../../utils/variables';

/**
 *  Resolves the locale key for the given issue code.
 *
 *  @param issueCode The issue code to resolve.
 *  @returns The locale key for the given issue
 */
export const resolveIssueCodeTranslation = (
  issueCode: IntegrationAuthenticationIssueCode,
): string => {
  switch (issueCode) {
    case 'integration_auth:integration_unauthorized':
      return t('issues.codeDescription.integration_auth.integration_unauthorized', {
        ns: 'integrations',
      });
    case 'integration_auth:skymap_unauthorized':
      return t('issues.codeDescription.integration_auth.skymap_unauthorized', {
        ns: 'integrations',
      });
    default:
      assertNever(issueCode);
  }
};
